import type { ComponentConfig } from '@puckeditor/core';
import { FAQAccordion } from './faq-accordion';
import { FAQAccordionFields } from "./faq-accordion.fields";
import type { FAQAccordionProps } from './faq-accordion';
import { RegenerableTextField } from "../editor/RegenerableTextField";

const FAQAccordionConfig: ComponentConfig<FAQAccordionProps> = {
  defaultProps: {
    faqs: [
      {
        answer:
          "We offer same-day service for most calls received before noon. For emergencies, we have technicians available 24/7 and can typically arrive within 1-2 hours.",
        question: "How quickly can you respond to service calls?",
      },
      {
        answer:
          "Yes, all of our technicians are fully licensed, bonded, and insured. We maintain comprehensive liability coverage and workers' compensation to protect both our team and your property.",
        question: "Are your technicians licensed and insured?",
      },
      {
        answer:
          "Yes, we provide free, no-obligation estimates for all services. Our technicians will assess your situation, explain your options, and provide upfront pricing before any work begins.",
        question: "Do you offer free estimates?",
      },
      {
        answer:
          "We accept all major credit cards, debit cards, cash, and checks. We also offer financing options for larger projects to help make your investment more manageable.",
        question: "What forms of payment do you accept?",
      },
      {
        answer:
          "Absolutely! We stand behind our work with a comprehensive warranty. Most services include a minimum 1-year labor warranty, and we honor all manufacturer warranties on parts and equipment.",
        question: "Do you offer any warranties on your work?",
      },
    ],
    heading: "Frequently Asked Questions",
    includeSchema: true,
    layout: "single-column",
    subheading: "Find answers to common questions about our services and process.",
  },
  fields: {
    heading: {
      ...FAQAccordionFields.heading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="faq.heading"
          label="Heading"
          multiline={false}
          fieldMeta={field?.metadata}
        />
      ),
    },
    subheading: {
      ...FAQAccordionFields.subheading,
      contentEditable: true,
      render: ({ value, onChange, field }) => (
        <RegenerableTextField
          value={value || ""}
          onChange={onChange}
          namespace="faq.subheading"
          label="Subheading"
          multiline={true}
          fieldMeta={field?.metadata}
        />
      ),
    },
    layout: FAQAccordionFields.layout,
    faqs: FAQAccordionFields.faqs as any,
    includeSchema: FAQAccordionFields.includeSchema,
    backgroundColor: FAQAccordionFields.backgroundColor,
  },
  label: "FAQ Accordion",
  render: ({ id, puck: _puck, editMode: _editMode, ...props }) => <FAQAccordion id={id} {...props} />,
};

export { FAQAccordionConfig };
